(ns minorodata.transform.subs
  (:require
   [minorodata.app.utils :as utils]
   [minorodata.utils :refer [find-by-field]]
   ["date-fns" :refer [isAfter subDays]]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]))


(re-frame/reg-sub
 :transform.subs/has-cycles?
 (fn [_]
   (re-frame/subscribe [:transformations-view/pull]))
 (fn [view [_ transform-id]]
   (let [{:transformations-view/keys [has-cycles edges]} view]
     (and has-cycles
          (contains? edges transform-id)))))


(defn format-panel-transform [{:transform/keys [id group-id master-id name input-tables output-tables updated-by updated-at
                                                schedule-spec stale ignore-parser modification-state environment-id]
                               :as             transform}
                              panel unsaved has-cycles? upstream-nodes?]
  (let [{:task-status/keys [status]} (-> transform :task-status/_transform last)
        [status-title status-style] (case status
                                      :connecting ["Connecting" :info]
                                      :starting ["Starting" :info]
                                      :running ["Running" :info]
                                      :skipped ["Skipped" :warn]
                                      :failed ["Failed" :error]
                                      :completed ["Completed" :success]
                                      nil)
        status       (:transform/status transform)
        unscheduled? (not (:cron schedule-spec))]
    {:id             id
     :transform-id   id
     :group-id       group-id
     :master-id      master-id
     :status         status
     :input-tables   input-tables
     :output-tables  output-tables
     :name           name
     :schedule       (utils/transform-schedule transform "Dependency based")
     :updated-at     updated-at
     :updated-by     (:searchable-user/username updated-by)
     :orphan?        (and (empty? input-tables) unscheduled?)
     :unsaved?       (some? unsaved)
     :stale?         (boolean stale)
     :paused?        (= :paused status)
     :selected?      (= id (get-in panel [:transforms-panel/active-transform :transform/id]))
     :has-cycles?    has-cycles?
     :upstream-deps? upstream-nodes?
     :unscheduled?   unscheduled?
     :status-title   status-title
     :status-style   status-style
     :manual-deps?   ignore-parser

     ;; env specific
     :environment-id     environment-id
     :modification-state modification-state}))


(re-frame/reg-sub
 :transform.subs/panel-transform
 (fn [[_ transform-id]]
   [(re-frame/subscribe [:transform/pull
                         [:transform/id transform-id]
                         '[* :transform/modification-state
                           {:transform/updated-by   [:searchable-user/username]
                            :task-status/_transform [:task-status/status]}]])
    (re-frame/subscribe [:transforms-panel/pull '[{:transforms-panel/active-transform [:transform/id]}]])
    (re-frame/subscribe [:unsaved-transform/pull [:unsaved-transform/id transform-id]])
    (re-frame/subscribe [:transform.subs/has-cycles? transform-id])
    (re-frame/subscribe [:dag.subs/connected-nodes? transform-id])])
 (fn [[transform panel unsaved has-cycles? upstream-nodes?]]
   (when (some? transform)
     (format-panel-transform transform panel unsaved has-cycles? upstream-nodes?))))

(defn format-transform-tags [tags]
  (if (seq tags)
    (mapv :value tags)
    []))


(def default-transform
  {:status        :active
   :is-temp       false
   :is-full       false
   :ignore-parser false
   :input-tables  []
   :output-tables []
   :command       ""
   :name          ""
   :description   ""
   :tags          []})


(defn format-edited-transform [transform unsaved-transform upstream-deps?]
  (let [{:transform/keys [schedule-spec]} transform
        edited-transform (if (some? unsaved-transform)
                           (utils/drop-ns-in-keys unsaved-transform)
                           (utils/drop-ns-in-keys transform))
        transform'       (merge default-transform edited-transform)]

    (-> transform'
        (update :tags format-transform-tags)
        (assoc :changed?       (some? unsaved-transform)
               :upstream-deps? upstream-deps?
               :scheduled?     (boolean schedule-spec)
               :updated-at     (:transform/updated-at transform)
               :updated-by     (get-in transform [:transform/updated-by :searchable-user/username])
               :created-at     (:transform/created-at transform)
               :created-by     (get-in transform [:transform/created-by :searchable-user/username])))))


(re-frame/reg-sub
 :transform.subs/edited-transform
 (fn [[_ transform-id]]
   [(re-frame/subscribe [:transform/pull
                         [:transform/id transform-id]
                         '[* {:transform/updated-by [:searchable-user/username]
                              :transform/created-by [:searchable-user/username]
                              :transform/tags       [:transform-tag/value]}]])

    (re-frame/subscribe [:unsaved-transform/pull
                         [:unsaved-transform/id transform-id]
                         '[* {:unsaved-transform/tags [:transform-tag/value]}]])
    (re-frame/subscribe [:dag.subs/connected-nodes? transform-id])])
 (fn [[transform unsaved-transform upstream-deps?]]
   (format-edited-transform transform unsaved-transform upstream-deps?)))


(re-frame/reg-sub
 :transform.subs/ordered-transforms
 (fn []
   (re-frame/subscribe
    [:transforms-panel/pull
     '[{:transforms-panel/transforms
        [:transform/id :transform/order :transform/name :transform/updated-at :transform/master-id :*
         {:transform/updated-by [:searchable-user/username]
          :transform/created-by [:searchable-user/username]}]}]]))
 (fn [panel]
   (let [{:transforms-panel/keys [transforms]} panel]
     (sort-by :transform/order transforms))))


(re-posh/reg-query-sub
 :transform.subs/transform-versions-by-master-id
 '[:find [?version-id ...]
   :in $ ?master-id
   :where [?version-id :transform-version/master-id ?master-id]])


(re-posh/reg-sub
 :transform.subs/transform-versions-raw
 (fn [[_ master-id]]
   (re-posh/subscribe [:transform.subs/transform-versions-by-master-id master-id]))
 (fn [versions-eids]
   {:type    :pull-many
    :pattern '[* {:transform-version/created-by [:searchable-user/username]}]
    :ids     versions-eids}))


(defn format-version [{:transform-version/keys [transform-id created-by created-at version-name]}]
  {:transform-id transform-id
   :created-by   (:searchable-user/username created-by)
   :created-at   created-at
   :version-name version-name})


(re-frame/reg-sub
 :transform.subs/transform-versions
 (fn [[_ master-id]]
   (re-posh/subscribe [:transform.subs/transform-versions-raw master-id]))
 (fn [versions]
   (->> versions
        (sort-by :transform-version/order)
        (map format-version))))


(def fields-to-compare
  {:name          {:key   :transform/name
                   :title "name"
                   :type  :string}
   :description   {:key   :transform/description
                   :title "description"
                   :type  :string}
   :schedule      {:key   :transform/schedule-spec
                   :title "schedule"
                   :type  :string}
   :ignore-parser {:key   :transform/ignore-parser
                   :title "manual dependencies"
                   :type  :boolean}
   :is-full       {:key   :transform/is-full
                   :title "replace existing table"
                   :type  :boolean}
   :is-temp       {:key   :transform/is-temp
                   :title "temporary table"
                   :type  :boolean}
   :input-tables  {:key   :transform/input-tables
                   :title "input tables"
                   :type  :chips}
   :output-tables {:key   :transform/output-tables
                   :title "output tables"
                   :type  :chips}
   :tags          {:key   :transform/tags
                   :title "tags"
                   :type  :chips}})


(re-frame/reg-sub
 :transform.subs/transform-metadata-changelist
 (fn [[_ transform-id selected-version-id]]
   [(re-frame/subscribe [:transform/pull [:transform/id transform-id] '[* {:transform/tags [:transform-tag/value]}]])
    (re-frame/subscribe [:transform/pull [:transform/id selected-version-id] '[* {:transform/tags [:transform-tag/value]}]])])
 (fn [[current previous]]
   (reduce
    (fn [changelist field]
      (let [{:keys [key title type]} (get fields-to-compare field)]
        (case field
          :schedule
          (let [prev-cron    (get-in previous [key :cron])
                current-cron (get-in current [key :cron])]
            (if (not= prev-cron current-cron)
              (conj changelist {:field    title
                                :type     type
                                :previous (utils/transform-schedule previous "Dependency based")
                                :current  (utils/transform-schedule current "Dependency based")})
              changelist))

          :tags
          (let [current-tags (mapv :transform-tag/value (get current key))
                prev-tags    (mapv :transform-tag/value (get previous key))]
            (if (not= current-tags prev-tags)
              (conj changelist {:field    title
                                :type     type
                                :previous prev-tags
                                :current  current-tags})
              changelist))

          (let [current-field (get current key)
                prev-field    (get previous key)]
            (if (not= current-field prev-field)
              (conj changelist {:field title :type type :previous prev-field :current current-field})
              changelist)))))

    []
    (keys fields-to-compare))))


(re-frame/reg-sub
 :transform.subs/get-preview-by-master-id
 (fn [db [_ master-id]]
   (get-in db [:transform/preview-versions master-id])))


(re-frame/reg-sub
 :transform.subs/versions-modal-params
 (fn [db _]
   (get db :transform.modals/version-history {})))

(re-frame/reg-sub
 :transform.subs/revert-circular-dependency-modal-params
 (fn [db _]
   (get db :transform.modals/revert-circular-deps {})))

(re-frame/reg-sub
 :transform.subs/full-transform
 (fn [[_ transform-id]]
   [(re-frame/subscribe [:transform/pull
                         [:transform/id transform-id]
                         '[*
                           {:transform/updated-by [:searchable-user/username]
                            :transform/created-by [:searchable-user/username]
                            :transform/tags       [:transform-tag/value]}]])
    (re-frame/subscribe [:group/pull-many '[:group/id :group/name]])])
 (fn [[transform groups]]
   (let [group    (find-by-field groups :group/id (:transform/group-id transform))]
     (some-> transform (assoc :transform/group group)))))

(re-frame/reg-sub
 :transform.subs/transform-run-status
 (fn []
   (re-frame/subscribe [:transform-status-list/prop :transform-status-list/statuses]))
 (fn [statuses [_ transform-id]]
   (find-by-field statuses :transform-id transform-id)))

(re-frame/reg-sub
 :transform.subs/failed-statuses-count
 (fn []
   (re-frame/subscribe [:transform-status-list/prop :transform-status-list/statuses]))
 (fn [statuses]
   (count (filter #(= (:status %) "failed") statuses))))


(re-frame/reg-sub
 :transform.subs/failed-statuses
 (fn []
   (re-frame/subscribe [:transform-status-list/prop :transform-status-list/statuses]))
 (fn [statuses]
   (filter #(= (:status %) "failed") statuses)))

(re-frame/reg-sub
 :transform.subs/failed-statuses-count-today
 (fn []
   (re-frame/subscribe [:transform-status-list/prop :transform-status-list/statuses]))
 (fn [statuses]
   (count (filter #(and (= (:status %) "failed")
                        (isAfter (js/Date. (:created-at %))
                                 (subDays (js/Date.) 1)))
                  statuses))))

(re-frame/reg-sub
 :transform.subs/failed-statuses-today
 (fn []
   (re-frame/subscribe [:transform-status-list/prop :transform-status-list/statuses]))
 (fn [statuses]
   (filter #(and (= (:status %) "failed")
                 (isAfter (js/Date. (:created-at %))
                          (subDays (js/Date.) 1)))
           statuses)))

(re-frame/reg-sub
 :transform.subs/by-master-id
 (fn [[_ master-id]]
   (re-frame/subscribe [:transform-master/pull [:transform-master/master-id master-id]
                        '[* {:transform-master/transform [* {:transform/updated-by [:searchable-user/username]
                                                             :transform/created-by [:searchable-user/username]
                                                             :transform/tags       [:transform-tag/value]}]}]]))
 (fn [transform-master]
   (some-> transform-master :transform-master/transform)))
